import { Color, Numeric } from "@siteimprove/alfa-css";
import { Style } from "../../style.js";
/**
 * @public
 */
export function hasOutline(device, context) {
    return (element) => {
        const style = Style.from(element, device, context);
        return (style.computed("outline-width").none(Numeric.isZero) &&
            style.computed("outline-style").none((style) => style.value === "none") &&
            style
                .computed("outline-color")
                .none((color) => color.type === "color" && Color.isTransparent(color)));
    };
}
//# sourceMappingURL=has-outline.js.map